import React from 'react';
import {TextComposer} from "./text-composer";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../../models/device.view-model";
import classNames from "classnames";

export class TextProps extends BaseProps {
  text: String;
  className: String;
  device: DeviceViewModel;
}

export const Text = TextComposer(({text, children, className, direction, style: propsStyle, ...rest}: TextProps) => {
  const outputText = text;
  const style = {
    ...(propsStyle || {})
  };

  if (direction) {
    style.direction = direction
  }

  const textProps = {
    className: classNames(className),
    style,
    ...rest
  };

  return (
    <div {...textProps}>
      {
        children
      }
      {
        outputText
      }
    </div>
  );
});
